import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './styles/base.less'
import BaseModal from './components/BaseModal.vue'
import VeeValidate from 'vee-validate'
// import * as PhotoSwipe from 'photoswipe'
// import * as PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

Vue.use(VeeValidate)
// Vue.use(PhotoSwipe)
// Vue.use(PhotoSwipeUI_Default)
Vue.component('base-modal', BaseModal)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
